import { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  FormControlLabel,
  Checkbox,
  TextField,
  Button,
  RadioGroup,
  FormLabel,
  FormControl,
  Radio,
} from "@mui/material";
import { UseDiscountCode } from "./UseDiscountCode";
import Detail from "../../../main/detail/Detail";
import { rsProgress, rsActiveMenu, rsGotoLast } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { toMoney, removeComma } from "../../../util/Utils";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function AddDiscountCode() {
  const navigate = useNavigate();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate, addDiscountCode, RandomDiscountCode } = UseDiscountCode();
  const [expireDate, setExpireDate] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [Code, setCode] = useState("");
  const [state, setState] = useState({
    discountCode: undefined,
    expireDate: undefined,
    discountCost: undefined,
    minOrderLimit: undefined,
    discountPercent: undefined,
    SMSID: undefined,
    freeDelivery: false,
    onlyFirstOrder: false,
    oneUse: false,
    allOneUse: false,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (Code) {
      setState({ ...state, discountCode: Code });
    }
  }, [Code]);

  useEffect(() => {
    let newValueStart = expireDate?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, expireDate: newValueStart });
  }, [expireDate]);

  const [errorState, setErrorState] = useState({
    discountCode: false,
  });
  const [value, setValue] = useState("");

  useEffect(() => {
    if (value == "allOneUse") {
      setState({ ...state, allOneUse: true, oneUse: false });
    } else if (value == "oneUse") {
      setState({ ...state, allOneUse: false, oneUse: true });
    }
  }, [value]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/discountmanagment",
        title: "محصولات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/discountmanagment",
          },
          {
            name: "کد تخفیف",
            url: "/discountmanagment/discountCode",
          },
          {
            name: "افزودن کد تخفیف",
            url: "/discountmanagment/discountCode/addCode",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 11" : "span 3"}>
          <TextField
            size="small"
            fullWidth
            id="outlined-basic"
            value={state.discountCode}
            label="کد تخفیف"
            error={errorState.discountCode}
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            focused={state.discountCode ? true : false}
            variant="outlined"
            onChange={(event) => {
              setState({
                ...state,
                discountCode: event.target.value,
              });
            }}
          />
        </Box>
        <Box sx={{ my: "auto" }} gridColumn="span 1">
          <Button
            onClick={() => {
              RandomDiscountCode((callBack) => {
                setCode(callBack);
              });
            }}
            sx={{ width: "100px" }}
            variant="contained"
          >
            ایجاد کد
          </Button>
        </Box>
        {!isSmall && <Box gridColumn="span 8"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <DatePicker
            // highlightToday={false}
            onOpenPickNewDate={false}
            weekDays={weekDays}
            calendar={persian}
            locale={persian_fa}
            format="YYYY-MM-DD"
            value={expireDate}
            onChange={setExpireDate}
            containerStyle={{
              width: "100%",
            }}
            render={
              <TextField
                sx={{ input: { textAlign: "center" } }}
                variant="outlined"
                size="small"
                fullWidth
                label="تاریخ انقضا"
              />
            }
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            size="small"
            fullWidth
            id="outlined-basic"
            value={state.discountCost ? toMoney(state.discountCost) : ""}
            label="مبلغ تخفیف (تومان)"
            variant="outlined"
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            onChange={(event) => {
              setState({
                ...state,
                discountCost: removeComma(event.target.value),
              });
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 8" : "span 2"}>
          <TextField
            size="small"
            fullWidth
            id="outlined-basic"
            value={state.discountPercent ? toMoney(state.discountPercent) : ""}
            label="درصد تخفیف"
            variant="outlined"
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            onChange={(event) => {
              setState({
                ...state,
                discountPercent: removeComma(event.target.value),
              });
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 10"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            size="small"
            fullWidth
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            id="outlined-basic"
            value={state.minOrderLimit ? toMoney(state.minOrderLimit) : ""}
            label="حداقل مبلغ سفارش (تومان)"
            variant="outlined"
            onChange={(event) => {
              setState({
                ...state,
                minOrderLimit: removeComma(event.target.value),
              });
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <Autocomplete
            size="small"
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            getOptionLabel={(option) => {
              return option;
            }}
            options={[]}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} label="پیغام SMS" />
            )}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <FormControlLabel
            checked={state.freeDelivery}
            onChange={(evt) => {
              setState({ ...state, freeDelivery: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="ارسال رایگان"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 5"}>
          <FormControlLabel
            checked={state.onlyFirstOrder}
            onChange={(evt) => {
              setState({ ...state, onlyFirstOrder: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="فقط برای سفارش اول"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 7"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 5"}>
          <Box sx={{ display: "flex" }} gridColumn="span 12">
            <FormControlLabel
              checked={state.oneUse}
              onChange={(evt) => {
                setState({ ...state, oneUse: evt.target.checked });
                if (evt.target.checked == false) {
                  setState({
                    ...state,
                    oneUse: evt.target.checked,
                    allOneUse: false,
                  });
                }
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="یکبار مصرف :"
            />
            <FormControl disabled={state.oneUse ? false : true}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={state.allOneUse}
                onChange={(event) => {
                  setState({ ...state, allOneUse: event.target.value });
                }}
              >
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="به ازای هر نفر"
                />
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="یکبار استفاده"
                />
              </RadioGroup>
            </FormControl>
          </Box>
        </Box>
        {!isSmall && <Box gridColumn="span 7"></Box>}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
          gridColumn={isSmall ? "span 12" : "span 4"}
        >
          <Button
            variant="contained"
            sx={{ mr: 2 }}
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                addDiscountCode(state, (callback) => {
                  setMsGotoLast(true);
                  navigate("/discountmanagment/discountCode", {
                    state: location.state,
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => {
              navigate("/discountmanagment/discountCode", {
                state: location.state,
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
